import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default {
  __name: 'App',
  setup(__props) {
    // import { useCommonStore } from '@/store/common'
    // import { onMounted } from 'vue'

    // onMounted(async () => {
    //   // 页面加载时获取数据
    //   const commonStore = useCommonStore()
    //   try {
    //     await commonStore.getBrandData()
    //     await commonStore.getUrl()
    //   } catch (error) {
    //     console.log(error)
    //   }
    // })

    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
};